import { mapState } from 'vuex'
import maNavbarCategory from '@/components/navbarCategories'
import maAcceptDamages from '@/components/button-blue'
import maNavbarStepper from '@/components/navbarStepper'
import { WARRANTY_MODULE_NAME } from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'
import moment from 'moment'

export default {
  name: 'damageResultUptec',

  mixins: [flowMixin, userFlowMixin],

  components: {
    maNavbarCategory,
    maAcceptDamages,
    maNavbarStepper
  },

  data: function () {
    return {
      titleCategory: ''
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyObjUptec: 'objUptec'
    }),

    flowName() {
      return this.getUserFlow
    },

    handleDateFormat() {
      return moment(this.stateWarrantyObjUptec.date).format('DD-MM-YYYY')
    }
  },

  methods: {
    handleClickGoToDamagesView() {
      window.removeEventListener('popstate', this.handleClickPrevPage)
      const damagesViewViewName = 'damages-view'
      this.goToView(damagesViewViewName)
    },

    handleClickPrevPage() {
      window.removeEventListener('popstate', this.handleClickPrevPage)
      const damageMobilierViewName = 'damageMobilier'
      const name = this.getDamageName
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      this.goToView(damageMobilierViewName, { propertyType, name, damageType })
    },

    /**
     * Gets the list with all the images and bases on its name it returns a list for each name
     */
    getImageSrc(imgName, imgList) {
      let imgSrc = []
      imgList.forEach((img) => {
        if (img.imageType === imgName) {
          imgSrc.push(img.imageContent)
        }
      })
      return imgSrc
    }
  },
  mounted () {
    window.addEventListener('popstate', this.handleClickPrevPage)
  }
}
